import axios from "axios";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Loader from "../loader/Loader";
import Player from "./player/Player";

const LiveChannel = () => {
    const [linkPlay, setLinkPlay] = useState("");
    const fetchLinkLive = () => {
        const dataPost = { id: "4009", device: "stbox" };
        const headers = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        axios
            .post("https://apiv2.hplus.com.vn/detail/", dataPost, { headers })
            .then((response) => setLinkPlay(response.data.content.link))
            .catch((err) => {
                console.log("Err", err);
            });
    };

    useEffect(() => {
        fetchLinkLive();
    }, []);

    return (
        <>
            {!linkPlay ? (
                <Loader />
            ) : (
                <Container className="player">
                    <Player link={linkPlay} controls={true} />
                </Container>
            )}
        </>
    );
};

const Container = styled.div`
    width: 650px;
    height: 350px;
    @media only screen and (max-width: 767px) {
        width: 100%;
        height: 100%;
    }
`;

export default React.memo(LiveChannel);
